import { mapObjIndexed, prop } from 'ramda'

import { getSmartSize } from '../helpers/styles'
import { useBackgroundStyle } from './background'
import { useBorderStyle } from './border'
import { useContrastColor } from '../../components/theme/_hooks/colors'
import { useMarginStyle } from './margin'
import { usePaddingStyle } from './padding'

export const useColorableSpaceStyle = ({ size, sizes, color, transparent, fullWidth, ...props }) => {
  color = color || 'primary'

  let widthValue = getSmartSize(size, mapObjIndexed(prop('width'), sizes), 'normal')
  if (fullWidth) widthValue = '100%'
  const heightValue = getSmartSize(size, mapObjIndexed(prop('height'), sizes), 'normal')
  const fontSizeValue = getSmartSize(size, mapObjIndexed(prop('fontSize'), sizes), 'p')

  let bgColor = color
  let contrastColor = useContrastColor(color)
  if (transparent) {
    bgColor = 'transparent'
    contrastColor = color
  }

  const style = `
      min-width: ${widthValue};
      min-height: ${heightValue};
      ${useBackgroundStyle({ bgColor, ...props })}
      ${useBorderStyle({ radius: 0.4, borderColor: color, ...props })}
      ${usePaddingStyle({ paddingH: 1.1, paddingV: 0.4, ...props })}
      ${useMarginStyle(props)}
    `

  return [style, contrastColor, fontSizeValue]
}
